<!-- SimpleFlexTable.vue -->
<script setup lang="ts">
    import { provide } from 'vue';

    const props = withDefaults(defineProps<{
        tableClass?: string,
        columnClasses?: string[],
        rowClass?: string
    }>(), {
        tableClass: "simple-table",
        firstColClass: "simple-cell",
        secondColClass: "simple-cell",
        rowClass: "simple-row simple-row-zebra"
    });

    provide('columnClasses', props.columnClasses);
    provide('rowClass', props.rowClass);

</script>

<template>
    <div class="simple-table">
        <slot></slot>
    </div>
</template>